import _ from 'lodash'

config.$inject = ['formlyConfigProvider']
export function config(formlyConfigProvider: any) {
  var type = {
    name: 'tinymce',
    wrapper: ['bootstrapLabel', 'bootstrapHasError'],
    template: require("!html-loader!./index.html").default
  }
  formlyConfigProvider.setType(type)
}